<div class="min-h-screen w-full min-w-0 overflow-x-hidden bg-cloud-mist">
  <div class="tfr-page-shell py-6">

    <header class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <p class="text-[10px] font-bold uppercase tracking-[0.2em] text-action-blue">TimeFlexRent</p>
        <h1 class="mt-1 text-[26px] font-bold tracking-tight text-midnight-indigo">Plantillas de correo</h1>
        <p class="mt-1 max-w-xl text-[13px] leading-relaxed text-steel-gray">
          Edita asunto y cuerpo por estado del flujo de reserva. Usa marcadores como <code class="text-[11px]" ngNonBindable>{{userName}}</code>.
        </p>
      </div>
      <div class="flex flex-wrap gap-2 shrink-0">
        <a routerLink="/admin/dashboard"
           class="inline-flex items-center gap-1.5 rounded-xl border border-pale-gray bg-white px-3 py-2 text-[12px] font-semibold text-slate-blue transition hover:border-action-blue/30 hover:text-action-blue">
          <lucide-icon name="layout-dashboard" [size]="14" />
          Panel
        </a>
        <button type="button" (click)="seedDefaults()" [disabled]="seeding() || loading()"
                class="inline-flex items-center gap-1.5 rounded-xl border border-action-blue/20 bg-action-blue/5 px-3 py-2 text-[12px] font-semibold text-midnight-indigo disabled:opacity-50">
          @if (seeding()) {
            <lucide-icon name="loader-circle" [size]="14" class="animate-spin" />
          } @else {
            <lucide-icon name="database" [size]="14" />
          }
          Crear plantillas por defecto
        </button>
      </div>
    </header>

    <!-- Correo transaccional (Resend) -->
    <section class="mb-6 rounded-2xl border border-pale-gray bg-white overflow-hidden" aria-label="Prueba de correo transaccional">
      <div class="border-b border-pale-gray px-4 py-4 sm:px-6">
        <div class="flex items-start gap-3">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-action-blue/10 text-action-blue">
            <lucide-icon name="mail" [size]="18" />
          </span>
          <div>
            <h2 class="text-[15px] font-bold text-midnight-indigo">Correo transaccional (Resend)</h2>
            <p class="mt-0.5 text-[12px] text-steel-gray">
              Verifica <code class="text-[11px]">RESEND_API_KEY</code>,
              <code class="text-[11px]">EMAIL_FROM</code> y
              <code class="text-[11px]">APP_PUBLIC_ORIGIN</code> en Cloud Functions.
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-end sm:px-6">
        <label class="min-w-0 flex-1">
          <span class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-steel-gray">
            Destinatario
          </span>
          <input
            type="email"
            [ngModel]="emailTestTo()"
            (ngModelChange)="emailTestTo.set($event)"
            placeholder="tu@email.com"
            autocomplete="email"
            class="w-full rounded-xl border border-pale-gray bg-white px-3 py-2.5 text-[13px] text-midnight-indigo placeholder:text-steel-gray focus:border-action-blue focus:outline-none focus:ring-2 focus:ring-action-blue/20" />
        </label>
        <button
          type="button"
          (click)="sendTestEmail()"
          [disabled]="emailTestSending()"
          class="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-action-blue px-4 py-2.5 text-[13px] font-semibold text-white transition hover:brightness-110 disabled:opacity-50">
          @if (emailTestSending()) {
            <lucide-icon name="loader-circle" [size]="16" class="animate-spin" />
            Enviando&hellip;
          } @else {
            <lucide-icon name="send" [size]="16" />
            Enviar correo de prueba
          }
        </button>
      </div>
      @if (emailTestSuccess(); as ok) {
        <p class="mx-4 mb-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-[12px] leading-relaxed text-emerald-900 sm:mx-6">{{ ok }}</p>
      }
      @if (emailTestError(); as err) {
        <p class="mx-4 mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[12px] leading-relaxed text-red-900 sm:mx-6">{{ err }}</p>
      }
    </section>

    <!-- Notificaciones push (FCM) -->
    <section class="mb-6 rounded-2xl border border-pale-gray bg-white overflow-hidden" aria-label="Prueba de push">
      <div class="border-b border-pale-gray px-4 py-4 sm:px-6">
        <div class="flex items-start gap-3">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-royal-amethyst/10 text-royal-amethyst">
            <lucide-icon name="bell" [size]="18" />
          </span>
          <div>
            <h2 class="text-[15px] font-bold text-midnight-indigo">Notificaciones push (FCM)</h2>
            <p class="mt-0.5 text-[12px] text-steel-gray">
              Envía una notificación de prueba a todos los dispositivos de admins con token FCM registrado.
            </p>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between px-4 py-4 sm:px-6">
        <p class="text-[12px] text-steel-gray">
          El token se registra al iniciar sesión en la app móvil y aceptar permisos.
        </p>
        <button
          type="button"
          (click)="sendTestPush()"
          [disabled]="pushTestSending()"
          class="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-royal-amethyst px-4 py-2.5 text-[13px] font-semibold text-white transition hover:brightness-110 disabled:opacity-50">
          @if (pushTestSending()) {
            <lucide-icon name="loader-circle" [size]="16" class="animate-spin" />
            Enviando&hellip;
          } @else {
            <lucide-icon name="bell" [size]="16" />
            Enviar push de prueba
          }
        </button>
      </div>
      @if (pushTestSuccess(); as ok) {
        <p class="mx-4 mb-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-[12px] leading-relaxed text-emerald-900 sm:mx-6">{{ ok }}</p>
      }
      @if (pushTestError(); as err) {
        <p class="mx-4 mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[12px] leading-relaxed text-red-900 sm:mx-6">{{ err }}</p>
      }
    </section>

    @if (loading()) {
      <p class="text-[13px] text-steel-gray">Cargando plantillas&hellip;</p>
    }

    @if (loadError(); as err) {
      <p class="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[12px] text-red-900">{{ err }}</p>
    }

    @if (!loading() && !loadError()) {
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-[220px_1fr]">

        <nav class="rounded-2xl border border-pale-gray bg-white p-2" aria-label="Plantillas">
          @for (entry of catalog; track entry.docId) {
            <button type="button"
                    (click)="selectDoc(entry.docId)"
                    class="w-full rounded-xl px-3 py-2.5 text-left transition"
                    [class.bg-action-blue/10]="selectedDocId() === entry.docId"
                    [class.text-action-blue]="selectedDocId() === entry.docId"
                    [class.text-slate-blue]="selectedDocId() !== entry.docId">
              <span class="block text-[12px] font-semibold leading-snug">{{ entry.navLabel }}</span>
              <span class="mt-0.5 block font-mono text-[10px] font-normal leading-tight text-steel-gray"
                    [class.text-action-blue]="selectedDocId() === entry.docId">{{ entry.docId }}</span>
            </button>
          }
        </nav>

        <div class="rounded-2xl border border-pale-gray bg-white p-4 sm:p-6">
          <div class="mb-4 flex flex-wrap items-center justify-between gap-2">
            <div>
              <h2 class="text-[16px] font-bold text-midnight-indigo">{{ catalogEntry(selectedDocId())?.navLabel }}</h2>
              @if (description()) {
                <p class="mt-0.5 text-[12px] text-steel-gray">{{ description() }}</p>
              }
            </div>
            <label class="inline-flex items-center gap-2 text-[12px] font-medium text-slate-blue cursor-pointer">
              <input type="checkbox" class="rounded border-pale-gray" [checked]="enabled()" (change)="enabled.set($any($event.target).checked)" />
              Envío activo
            </label>
          </div>

          <details class="mb-4 rounded-xl border border-pale-gray bg-cloud-mist px-3 py-2 text-[11px] text-steel-gray">
            <summary class="cursor-pointer font-semibold text-midnight-indigo">Marcadores disponibles</summary>
            <ul class="mt-2 space-y-1 font-mono text-[10px]">
              @for (hint of tokenHints; track hint.key) {
                <li><span class="text-midnight-indigo">{{ hint.key }}</span> — {{ hint.label }}</li>
              }
            </ul>
            <p class="mt-2 text-[10px] text-steel-gray">En la plantilla escribe cada marcador entre dobles llaves, por ejemplo <span class="font-mono" ngNonBindable>{{userName}}</span>.</p>
          </details>

          <label class="mb-4 block">
            <span class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-steel-gray">Asunto</span>
            <input type="text" class="w-full rounded-xl border border-pale-gray px-3 py-2.5 text-[13px] text-midnight-indigo focus:border-action-blue focus:outline-none focus:ring-2 focus:ring-action-blue/20"
                   [ngModel]="subject()" (ngModelChange)="subject.set($event)" />
          </label>

          <label class="mb-4 block">
            <span class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-steel-gray">Cuerpo HTML (interior del layout)</span>
            <textarea rows="14" class="w-full rounded-xl border border-pale-gray px-3 py-2.5 font-mono text-[12px] leading-relaxed text-midnight-indigo focus:border-action-blue focus:outline-none focus:ring-2 focus:ring-action-blue/20"
                      [ngModel]="bodyHtml()" (ngModelChange)="bodyHtml.set($event)"></textarea>
          </label>

          <label class="mb-6 block">
            <span class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-steel-gray">Texto plano (opcional)</span>
            <textarea rows="6" class="w-full rounded-xl border border-pale-gray px-3 py-2.5 font-mono text-[12px] leading-relaxed text-midnight-indigo focus:border-action-blue focus:outline-none focus:ring-2 focus:ring-action-blue/20"
                      [ngModel]="bodyText()" (ngModelChange)="bodyText.set($event)"></textarea>
          </label>

          @if (saveSuccess(); as ok) {
            <p class="mb-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-[12px] text-emerald-900">{{ ok }}</p>
          }
          @if (saveError(); as err) {
            <p class="mb-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[12px] text-red-900">{{ err }}</p>
          }

          <button type="button" (click)="save()" [disabled]="saving()"
                  class="inline-flex items-center gap-2 rounded-xl bg-action-blue px-4 py-2.5 text-[13px] font-semibold text-white transition hover:brightness-110 disabled:opacity-50">
            @if (saving()) {
              <lucide-icon name="loader-circle" [size]="16" class="animate-spin" />
              Guardando&hellip;
            } @else {
              <lucide-icon name="save" [size]="16" />
              Guardar plantilla
            }
          </button>
        </div>
      </div>
    }
  </div>
</div>
